/**
 * The two pieces every add-in oraChat call shares (outlook-orachat-uplift s4,
 * CR-9): the fetch it sends with, and the header trio it carries. The chat
 * user read (`chatUser.ts`) and the panel's transport
 * (`addinOraChatTransport.ts`) both use these; header names come from
 * `config/oraHeaders.ts`.
 */

import { ORA_ADDIN_HEADERS, ORA_ADDIN_SURFACE_STAMP } from "../config/oraHeaders";

/** `fetchImpl` when given, else the platform fetch looked up per call (so a
 *  test's `global.fetch` stub installed later is still the one used). */
export function addinFetch(fetchImpl?: typeof fetch): typeof fetch {
  return fetchImpl ?? ((...args) => globalThis.fetch(...args));
}

/** The bearer, the `X-Ora-Surface` stamp and the correlation id. */
export function addinCallHeaders(token: string, correlationId: string): Record<string, string> {
  return {
    [ORA_ADDIN_HEADERS.authorization]: `Bearer ${token}`,
    [ORA_ADDIN_HEADERS.surface]: ORA_ADDIN_SURFACE_STAMP,
    [ORA_ADDIN_HEADERS.correlationId]: correlationId,
  };
}
